export default __webpack_public_path__ + "static/media/Dia-internacional-das-Mulheres-8M-3.e93e1110.jpg";